import { MultiSelect } from './MultiSelect';

export const LipidClassSelector = ({disabled, lipidClasses, selectedLipidClasses, onChange }) => {
  return (
    <div className="mb-3 card card-body">
      <label className="form-label" htmlFor="lipidClassSelector">
        Lipid Class to optimize
      </label>
      <MultiSelect
        closeMenuOnSelect={false}
        isMulti
        isClearable
        isSearchable
        options={lipidClasses}
        isDisabled={disabled}
        value={selectedLipidClasses}
        isOptionDisabled={(option) => option.disabled}
        onChange={(selected) => onChange(selected)}
      />
    </div>
  )
}

